import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, InternalUserModel } from 'src/app/Services/AuthService/auth-service.service';
import { Notification_Service } from 'src/app/Services/Notifications/notification.service';


declare var $: any;
declare var kendo: any;
//test deployment.
@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAgentComponent implements OnInit {
  public checked = true;
  guid:string;
  title = 'Registration-Portal';
  responseOutput = 'Please enter your credentials.';
  currentTab="";

  validateUserIcon=false;
  enableLoginButn=false;
  emailOk=false;

  showSpinner=false;
  showSpinnerUser=false;
  timer = null;
  cardWidth=100;
  isAccountcreated=false;
  showAccountcreatedMessage=false;
  isUserNameAvailabe: boolean=false;

    user: InternalUserModel={
    _agentId:"",
    _agentGuid:"",
    _username:"",
    _email:"",
    _emailTwo:"",
    _phone:"",
    _phone2:"",
    _agentName :"",
    _password :"",
    _confPassword :"",
    _AgentAddress1 :"",
    _AgentAddress2 :"",
    _AgentAddress3 :"",
    _AgentAddress4 :"",
    _AgentAddress5 :"",
    _fax:"",
    _business:"",
    _contact:"",
  }
  public usernameAllowance = {
        title: 'Username Allows only',
        item1:'Alphanumeric characters [a – z] or uppercase [A – Z]',
        item2:'Digits [0 – 9] and underscores (_). Min 8 chars long.',
  };
  public passwordRequirements = {
    title: 'Password Requirements',
    item1:'At least 8 characters. A mixture of both uppercase and lowercase letters.',
    item2:'A mixture of letters and numbers. Include at least one special character.'
};
  

  constructor(private _authService:AuthService, private router: Router, private notificationService: Notification_Service, private activatedRoute: ActivatedRoute) {
    // String.prototype.matchAll()
   }

  ngOnInit() {
    this._authService.doLogoutUser(false)
    this._authService.selectedUser.subscribe(x=>{
      if(x){
        if(x._username){
          this.isAccountcreated =true;
          this.showAccountcreatedMessage =true;
        }
        this.user =x;
      }
    });

    $(document).ready(function () {
      $("#authentication-wrapper").hover(function () {
        kendo.fx($("#authentication-wrapper")).zoom("in").startValue(1).endValue(1.05).play();
      }, () => {
        kendo.fx($("#authentication-wrapper")).zoom("out").endValue(1).startValue(1.05).play();
      });
    })

    this.activatedRoute.params.subscribe(params => {
      this.guid = params['id']; //Value passed in the URL should be a GUID
      this._authService.authenticate(this.guid)
    });
  }

  activateAccount() {
   this.showSpinner =true
   this._authService.createAccount(this.user).subscribe((res:any) => {
     this.showSpinner =false;
     this.isAccountcreated= true;
     this.notificationService.successNotif("Your account was created successfuly. Navigate to the sign in page to start your session.", false);
    },
    error =>{
      debugger
      this.showSpinner =false;
      this.isAccountcreated= false;
      this.notificationService.errorNotif("There was an error at the time of activating your account.");
      console.log(error.error);
    });
  }
  

  enteredUsername(value:string){// Username on input
    this.validateUserIcon=false;
    if(new RegExp("^[A-Za-z0-9_-]{8,}$").test(value)){
      this._authService.checkUserNameAvailability(value).subscribe((data:any) => {

        this.showSpinnerUser =false;
        if(data.isUserNameAvailable && this._authService.dataStore.selectedUser){
          window.clearTimeout(this.timer); 
          this.timer = null;
          this.showSpinnerUser =true

          this.timer =setTimeout(() => {
            this.isUserNameAvailabe = data.isUserNameAvailable;
            this.validateUserIcon   = data.isUserNameAvailable;
            this.showSpinnerUser =false;
            this.validateUserIcon =true;
            this.isUserNameAvailabe=false;
            this.notificationService.successNotif("The selected Username is available. Please Proceed to Enter Your Password.",false);
          }, 2300);
        }
        else{
          window.clearTimeout(this.timer); 
          this.timer = null;
          this.showSpinnerUser =true

          if(this._authService.dataStore.selectedUser){
            this.timer =setTimeout(() => {
              this.showSpinnerUser =false;
              this.validateUserIcon =false;
              this.isUserNameAvailabe=false;
              this.notificationService.errorNotif("The selected Username is Not available.");
            }, 2300);
          }
          else{
            this.timer =setTimeout(() => {
              this.showSpinnerUser =false;
              this.validateUserIcon =false;
              this.isUserNameAvailabe=false;
              this.notificationService.errorNotif("Unable to set Username for Unidentified User/Please contact your app admin. Error: wrong GUID :" + this.guid);
            }, 2300);
          }
        }
      }, error =>{
        debugger
      });
    }
    else{
        this.showSpinnerUser =false;
        this.validateUserIcon =false;
        this.isUserNameAvailabe=false;
    }
  }

  checkPassword(){  //implement service for error message
    //     r'^
    //   (?=.*?[A-Z])         // should contain at least one upper case
    //   (?=.*?[a-z])         // should contain at least one lower case
    //   (?=.*?[0-9])         // should contain at least one digit
    //   (?=.*?[#?!@$%^&*-_]) // should contain at least one Special character
    //   .{8,}                // Must be at least 8 characters in length  
    // $
    if(  this.user._password=== this.user._confPassword 
         && new RegExp(`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$`).test(this.user._password)){
      this.enableLoginButn =true;
    }
    else{
      this.enableLoginButn =false;
    }
  }

  navigateToLogin(){
    this.router.navigateByUrl('/sign-in');
  }
}
